module.exports = __webpack_public_path__ + "static/teleco_7-a14945e9e491e907eb15ac8ad240e73f.jpg";